/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsTopActionableIssuesResponse {
    getFixupPrototypeFunction() { return AppSecopsTopActionableIssuesResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsTopActionableIssuesResponse>): AppSecopsTopActionableIssuesResponse {
        let obj = Object.assign(new AppSecopsTopActionableIssuesResponse(), model);
        AppSecopsTopActionableIssuesResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsTopActionableIssuesResponse>): AppSecopsTopActionableIssuesResponse {
        if (!model) return null;
        return AppSecopsTopActionableIssuesResponse.newInstance(<AppSecopsTopActionableIssuesResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsTopActionableIssuesResponse) {
        if (!obj) return;

        models.AppSecopsTopActionableIssuesResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsTopActionableIssuesResponse): boolean {
        Object.setPrototypeOf(obj, AppSecopsTopActionableIssuesResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.results) {
            for (let val of this.results) {
                models.AppSecopsDashboardInsights.fixupPrototype(val);
            }
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<models.AppSecopsDashboardInsights>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
